import { Box } from '@chakra-ui/react';
import { useSession } from 'next-auth/react';

import {
    adminShoppingMenu,
    loggedUserShoppingMenu,
    unLoggedUserShoppingMenu,
    vipPartnerUserShoppingMenu
} from '@/data/menu';

import { CurrentOffer } from '@/components/Navigation/ShoppingNavigation/CurrentOffer';
import { useCurrentUser } from '../../../context/currentUserContext';

export const ShoppingNavigationBar = () => {
    const { data } = useSession();
    const { currentUser } = useCurrentUser();
    const shoppingMenu = data?.user
        ? currentUser?.b2bRole === 'ADMIN'
            ? adminShoppingMenu
            : currentUser?.b2bRole === 'VIP_PARTNER'
                ? vipPartnerUserShoppingMenu
                : loggedUserShoppingMenu
        : unLoggedUserShoppingMenu;

    return (
        <>
            <Box as="nav">
                <CurrentOffer
                    menu={shoppingMenu}
                    display="inline"
                    textAlign="right"
                    flexWrap="nowrap"
                    listStyleType="none"
                    mx={0}
                    alignItems="center"
                    justifyContent="center"
                />
            </Box>
        </>
    );
};
